import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from '../Home/Home';
import Misc from '../Misc/Misc';
import MainBatuLagi from '../Misc/MainBatuLagi/MainBatuLagi';
import TlxGroupVerdict from '../Misc/TlxGroupVerdict/TlxGroupVerdict';
import './Main.css';

const Main = () => {
    return (
        <div className='main'>
            <Switch>
                <Route exact path='/'><Home /></Route>
                <Route exact path='/misc'><Misc /></Route>
                <Route exact path='/misc/tgv'><TlxGroupVerdict /></Route>
                <Route exact path='/misc/mbl'><MainBatuLagi /></Route>
            </Switch>
        </div>
    );
}

export default Main;